import type { JSONContent } from "@tiptap/core";

/**
 * Non-breaking spaces that arrive via paste from Word/Outlook HTML
 * (`&nbsp;`). A paragraph whose spaces are all U+00A0 is one giant "word"
 * for the browser, and `overflow-wrap: break-word` then breaks it at an
 * arbitrary letter at the line end ("den A|nforderungen").
 */
const NON_BREAKING_SPACES_RE = /[  ]/g;

const normalizeNode = (node: JSONContent): JSONContent => {
  if (node.type === "text" && typeof node.text === "string") {
    const text = node.text.replace(NON_BREAKING_SPACES_RE, " ");
    return text === node.text ? node : { ...node, text };
  }

  if (!Array.isArray(node.content)) return node;

  let changed = false;
  const content = node.content.map((child) => {
    const next = normalizeNode(child);
    if (next !== child) changed = true;
    return next;
  });
  return changed ? { ...node, content } : node;
};

/**
 * Replaces non-breaking spaces in all text nodes with regular spaces.
 * Returns the same reference when nothing changed.
 */
export function normalizeTiptapWhitespace(content: JSONContent): JSONContent {
  return normalizeNode(content);
}
